var Multiaddr = require('multiaddr');

var reduceValue = function reduceValue(_, v) {
  return v;
};

var Reducers = {
  ip4: reduceValue,
  ip6: function ip6(str, content, i, parts) {
    return parts.length === 1 && parts[0].protocol === 'ip6' ? content : "[".concat(content, "]");
  },
  tcp: function tcp(str, content, i, parts) {
    return parts.some(function (p) {
      return ['http', 'https', 'ws', 'wss'].includes(p.protocol);
    }) ? "".concat(str, ":").concat(content) : "tcp://".concat(str, ":").concat(content);
  },
  udp: function udp(str, content) {
    return "udp://".concat(str, ":").concat(content);
  },
  dnsaddr: reduceValue,
  dns4: reduceValue,
  dns6: reduceValue,
  ipfs: function ipfs(str, content) {
    return "".concat(str, "/ipfs/").concat(content);
  },
  p2p: function p2p(str, content) {
    return "".concat(str, "/p2p/").concat(content);
  },
  http: function http(str) {
    return "http://".concat(str);
  },
  https: function https(str) {
    return "https://".concat(str);
  },
  ws: function ws(str) {
    return "ws://".concat(str);
  },
  wss: function wss(str) {
    return "wss://".concat(str);
  },
  'p2p-websocket-star': function p2pWebsocketStar(str) {
    return "".concat(str, "/p2p-websocket-star");
  },
  'p2p-webrtc-star': function p2pWebrtcStar(str) {
    return "".concat(str, "/p2p-webrtc-star");
  },
  'p2p-webrtc-direct': function p2pWebrtcDirect(str) {
    return "".concat(str, "/p2p-webrtc-direct");
  }
};

module.exports = function (multiaddr) {
  return Multiaddr(multiaddr).stringTuples().map(function (tuple) {
    return {
      protocol: Multiaddr.protocols.codes[tuple[0]].name,
      content: tuple[1]
    };
  }).reduce(function (str, part, i, parts) {
    var reduce = Reducers[part.protocol];
    if (!reduce) throw new Error("Unsupported protocol ".concat(part.protocol));
    return reduce(str, part.content, i, parts);
  }, '');
};